var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainBanner',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      throttle: 300}),expression:"{\n      throttle: 300}"}]}),_c('OurServices',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal",value:({ delay: 120 }),expression:"{ delay: 120 }"},{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.visibilityChanged,
      throttle: 300,
    }),expression:"{\n      callback: visibilityChanged,\n      throttle: 300,\n    }"}],attrs:{"services":_vm.DataWeb.specialized.items}}),_c('AboutUs',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal",value:({ delay: 120 }),expression:"{ delay: 120 }"},{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.visibilityChanged,
      throttle: 500,
      intersection: {
        threshold: 0.34
      }
    }),expression:"{\n      callback: visibilityChanged,\n      throttle: 500,\n      intersection: {\n        threshold: 0.34\n      }\n    }"}]}),_c('Community',{directives:[{name:"scroll-reveal",rawName:"v-scroll-reveal",value:({ delay: 120 }),expression:"{ delay: 120 }"},{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.visibilityChanged,
      throttle: 500,
      intersection: {
        threshold: 0.34
      }
    }),expression:"{\n      callback: visibilityChanged,\n      throttle: 500,\n      intersection: {\n        threshold: 0.34\n      }\n    }"}]}),_c('MainFooter',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({
      callback: _vm.visibilityChanged,
      throttle: 500,
      intersection: {
        threshold: 0.34
      }
    }),expression:"{\n      callback: visibilityChanged,\n      throttle: 500,\n      intersection: {\n        threshold: 0.34\n      }\n    }"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }